export const tokenMiddleware = store => next => action => {
    next(action);
};


// WEBPACK FOOTER //
// ./src/middleware.js